import { useNavigate } from 'react-router-dom'
import { BarChart3, RotateCcw, ScrollText, Settings2 } from 'lucide-react'
import SectionNav from '../../components/SectionNav'
import {
  analysisStrings as A,
  gamificationSettingsStrings as G,
  resetLogsStrings as R,
  transactionsStrings as T,
} from './strings'

/**
 * التلعيب's four screens, as one strip.
 *
 * They are four ROUTES rather than four tabs of one page, and until now only
 * two of them knew about each other: the points log carried a two-item switch
 * between itself and the reset log, while النتائج and الإعدادات sat outside it
 * with no way across except the sidebar. So the same area offered in-page
 * navigation on half its screens and none on the other half.
 *
 * `value` + `onChange` rather than four `to` links, deliberately: SectionNav
 * draws a chevron on an item that carries `to` — "this leaves for another page"
 * — and with all four leaving, four chevrons say nothing that the strip does
 * not already say. These read as sections because that is what they are to the
 * person using them; the navigate is an implementation detail.
 *
 * @param {'analysis'|'transactions'|'resetLogs'|'settings'} value  which screen
 *   is open. The page passes its own id rather than the strip reading the URL:
 *   the points log serves two of these routes from one component, so the route
 *   alone does not identify the screen.
 */
const SCREENS = [
  { id: 'analysis', label: A.title, to: '/gamification/analysis', icon: BarChart3 },
  { id: 'transactions', label: T.title, to: '/gamification/transactions', icon: ScrollText },
  { id: 'resetLogs', label: R.title, to: '/gamification/reset-logs', icon: RotateCcw },
  { id: 'settings', label: G.title, to: '/gamification/settings', icon: Settings2 },
]

export default function GamificationNav({ value }) {
  const navigate = useNavigate()

  return (
    <SectionNav
      groups={[{ items: SCREENS.map(({ to: _to, ...item }) => item) }]}
      value={value}
      onChange={(id) => navigate(SCREENS.find((screen) => screen.id === id).to)}
      ariaLabel={G.subtitle}
    />
  )
}
